import { S3_BASE_URL } from 'constants/static';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isLoginFormOpenState, isMenuOpenState, shopState } from 'store/atoms';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  display: flex;
  background-color: #fff;
  height: 58px;
  padding: 16px 20px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eaebef;
  z-index: 1001; /* 사이드 메뉴보다 위에 */
`;

const Logo = styled.div`
  width: 375px;
  height: 58px;
  display: flex;
  align-items: center;

  img {
    height: auto;
    max-height: 40px;
    object-fit: contain;
  }
`;

const MenuButton = styled.button<{ $isOpen: boolean }>`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1000;
`;

export function CommonHeader() {
  const isMenuOpen = useRecoilValue(isMenuOpenState);
  const isLoginFormOpen = useRecoilValue(isLoginFormOpenState);
  const setIsMenuOpen = useSetRecoilState(isMenuOpenState);
  const setIsLoginFormOpen = useSetRecoilState(isLoginFormOpenState);
  const shop = useRecoilValue(shopState);

  const handleMenuClick = () => {
    if (isLoginFormOpen) {
      setIsLoginFormOpen(false);
    } else {
      setIsMenuOpen(!isMenuOpen);
    }
  };

  const iconSrc = () => {
    if (isMenuOpen || isLoginFormOpen) {
      return `${S3_BASE_URL}/close_icon.svg`;
    }

    return `${S3_BASE_URL}/menu_icon.svg`;
  };

  return (
    <>
      <HeaderContainer>
        <Logo
          onClick={() => {
            window.location.href = '/?shop=' + shop?.shopName;
          }}
        >
          <img src={`${S3_BASE_URL}/kaddie_new_header_logo.svg`} alt="kaddie header logo" />
        </Logo>
        <MenuButton $isOpen={isMenuOpen} onClick={handleMenuClick}>
          <img src={iconSrc()} alt="menu_icon" width={24} height={24} />
        </MenuButton>
      </HeaderContainer>
    </>
  );
}
